type StatusItemDTO = {
  id: number;
  name: string;
  statusId: string | string[];
};

export const statusItems: StatusItemDTO[] = [
  {
    id: 2,
    name: 'Em análise',
    statusId: [
      'FECHAR',
      'EM_ANALISE',
      'NOT_DELIVERED_MUTABLE',
      'AGUCONLOG',
      'GERPEDAUT',
      'AGUANA',
      'ERRINT',
      'RENDATCLI',
      'PEDIDO_EM_ANALISE',
      'AGUTRA',
      'GREOSAUT',
      'CANEA',
    ],
  },
  {
    id: 3,
    name: 'Agendado',
    statusId: ['AGENDADO', 'PEDAGE', 'AGEREA'],
  },
  {
    id: 4,
    name: 'Confirmado',
    statusId: 'CONFIRMADO',
  },
  {
    id: 5,
    name: 'Em rota',
    statusId: 'EM_ROTA',
  },
  {
    id: 6,
    name: 'Atendido',
    statusId: 'ATENDIDO',
  },
  {
    id: 7,
    name: 'Reagendado',
    statusId: 'REPROGRAMADO',
  },
  {
    id: 8,
    name: 'Não atendido',
    statusId: 'NAO_ATENDIDO',
  },
];
